import styled from 'styled-components';

import { Marquee } from '#src/atoms/container/Marquee/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BrandS } from '#src/atoms/typography/index.tsx';
import { DotsBackgroundBezel } from '#src/atoms/ui/DotsBackgroundBezel/index.tsx';
import { Img } from '#src/atoms/ui/Img/index.tsx';

const Root = styled.div`
  margin-top: var(--double-unit);
`;

const LogoWrapper = styled(Vertical).attrs({ gap: 2, center: true })`
  height: 140px;
  width: 180px;
  padding: var(--triple-unit);
  text-align: center;
`;

const So5CompetitionLogo = styled(Img)`
  object-fit: contain;
`;

type League = {
  id?: string;
  displayName: string;
  pictureSecondaryUrl: string | null;
};

type Props = {
  leagues: League[];
};
export const LogoBezelMarquee = ({ leagues }: Props) => {
  return (
    <Root>
      {!!leagues.length && (
        <Marquee gap={5}>
          {leagues.map(
            ({ displayName, pictureSecondaryUrl }) =>
              pictureSecondaryUrl && (
                <DotsBackgroundBezel
                  mouseHoverEffect={{
                    color: 'var(--c-white)',
                    size: 50,
                    enabled: true,
                  }}
                  key={displayName}
                >
                  <LogoWrapper center>
                    <So5CompetitionLogo
                      src={pictureSecondaryUrl}
                      alt={displayName}
                      width="70"
                      height="70"
                      title={displayName}
                    />
                    <BrandS>{displayName}</BrandS>
                  </LogoWrapper>
                </DotsBackgroundBezel>
              )
          )}
        </Marquee>
      )}
    </Root>
  );
};
